import React, {Dispatch, useState} from 'react';

import {Button} from 'components/ui-kit/Button';
import {Modal} from 'components/ui-kit/Modal';
import {Textarea} from 'components/ui-kit/Textarea';
import {CryptoProCert} from 'types/plugins/cadesPlugin';

export const CertMockModal = ({
    show,
    setShow,
    addCert,
}: {
    show: boolean;
    setShow: Dispatch<boolean>;
    addCert: Dispatch<CryptoProCert>;
}) => {
    const [cert, setCert] = useState('');
    const onAdd = () => {
        try {
            const parsed = JSON.parse(cert) as CryptoProCert;
            addCert(parsed);
            setShow(false);
        } catch (error) {
            console.error('JSON parsing error:', error.message);
        }
    };
    return (
        <Modal title="Enter mock certificate" show={show} onClose={() => setShow(false)}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '10px',
                }}
            >
                <Textarea
                    style={{height: 250}}
                    value={cert}
                    onChange={(e) => setCert(e.target.value)}
                />
                <Button onClick={onAdd} style={{width: 240}}>
                    + Add mock certificate
                </Button>
            </div>
        </Modal>
    );
};
